export const DEFAULT_ZOOM_LEVEL = 15

export const 숭례문_좌표: naver.maps.PointObjectLiteral = {
  x: 126.9753282,
  y: 37.5599922,
}

// 점 마커 사이즈 (border 1px * 2 포함)
export const BIG_DOT_MARKER_SIZE = 13
export const DOT_MARKER_SIZE = 10

export const DEFAULT_TRANSITION_OPTIONS: naver.maps.TransitionOptions = {
  duration: 500,
  easing: 'easeOutCubic',
}

export const DEFAULT_FIT_BOUNDS_MARGIN: naver.maps.Margin = {
  top: 20,
  right: 20,
  bottom: 20,
  left: 20,
}

export const markerZIndex = {
  SELECTED: 300,
  UPCOMING: 250,
  IMAGE: 200,
  NORMAL: 100,
} as const
